import { AppProps } from 'src/app/App';
import { datalayerInstance } from '../..';
import categoryPageAttributes from '../../category-page-attributes';

export const categoryPageEngagementDatalayer = ({ ...props }: AppProps) => {
  datalayerInstance().add({
    name: 'category',
    data: categoryPageAttributes(props),
  });
};
